import MainButton from '@/components/ui/custom/buttons/MainButton';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import Text from '@/components/ui/custom/dataDisplay/Text';
import { VersioningStatusEnum } from '@/enums/VersioningStatus';
import CoursePath from '@/models/CoursePath';
import { EyeIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { useTranslation } from 'react-i18next';
import DeleteAction from './DeleteAction';
import InformationAction from './InformationAction';
import PublishAction from './PublishAction';
import PushToBetaAction from './PushToBetaAction';

type CourseHeaderActionsProps = {
  coursePath: CoursePath;
};

const CourseHeaderActions = React.memo(function CourseHeaderActions({
  coursePath,
}: CourseHeaderActionsProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseBox.actions',
  });

  return (
    <nav className="flex gap-2.5 w-fit items-center flex-wrap justify-end">
      <MainButton
        text={t('view')}
        color="custom"
        className="font-500 !text-14 text-primary gap-1 flex-row-reverse"
        href={`/courses/${coursePath.slug}`}
        icon={
          <EyeIcon
            className={'w-4 h-4 ease-in-out transition-all duration-200'}
            strokeWidth={2}
          />
        }
      />

      <InformationAction coursePath={coursePath} />
      <ConditionalRenderer
        condition={coursePath.status === VersioningStatusEnum.VERSIONING}
      >
        <PushToBetaAction coursePath={coursePath} />
      </ConditionalRenderer>
      <ConditionalRenderer
        condition={coursePath.status === VersioningStatusEnum.EDITING}
      >
        <PublishAction coursePath={coursePath} />
      </ConditionalRenderer>
      <ConditionalRenderer
        condition={coursePath.status === VersioningStatusEnum.VERSIONING}
      >
        <DeleteAction coursePath={coursePath} />
      </ConditionalRenderer>
      <Text
        format="rubik-500"
        text={`v${coursePath.version.toFixed(1)}`}
        className="text-14 text-secondary"
      />
    </nav>
  );
});

export default CourseHeaderActions;
